import {configureCommands} from "./configure-commands.js";

configureCommands();
